import {storesMap} from "../storesMap/storesMap";
import {markerWraper} from "../storesMap/markerWrapper";
import GMap = google.maps.Map;
import StreetViewPanorama = google.maps.StreetViewPanorama;
declare const window:any;


export class SingleStoreMap extends storesMap {

    panorama:StreetViewPanorama = null;

    /**
     * Initializes th google maps
     * @param conf
     */
    initMap() {
        let store = window.STORE_MAP;
        const location = `${store.store_location_gmap.lat},${store.store_location_gmap.lng}`;
        let img = document.createElement('img');
        const img_height = document.getElementById('storeMap').clientHeight;
        let img_width = document.getElementById('storeMap').clientWidth;
        if (img_width > 640) img_width = 640;
        const icon = window.MARKERS_ICON;
        img.setAttribute('src', `https://maps.googleapis.com/maps/api/staticmap`+
                         `?center=${location}`+
                         `&key=AIzaSyAsi4qXf2C0hMxDcMPTTLQlqSFhrew3Z_Y`+
                         `&size=${img_width}x${img_height}&zoom=14`+
                         `&markers=anchor:bottom|icon:${icon}|${location}`);
        img.setAttribute('alt', 'Static map');
        document.getElementById('storeMap').appendChild(img);
    }

    // Redefining just to keep consistency with the parent class.
    initMarkers() { }
    toogleSatteliteView(map:GMap) {}
    toggleStreetView(panorama) {}
    addIEOverlay() {}
}

const mapStyle = [{"elementType":"geometry","stylers":[{"hue":"#ff4400"},{"saturation":-68},{"lightness":-4},{"gamma":0.72}]},{"featureType":"road","elementType":"labels.icon"},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"hue":"#0077ff"},{"gamma":3.1}]},{"featureType":"water","stylers":[{"hue":"#00ccff"},{"gamma":0.44},{"saturation":-33}]},{"featureType":"poi.park","stylers":[{"hue":"#44ff00"},{"saturation":-23}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"hue":"#007fff"},{"gamma":0.77},{"saturation":65},{"lightness":99}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"gamma":0.11},{"weight":5.6},{"saturation":99},{"hue":"#0091ff"},{"lightness":-86}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"lightness":-48},{"hue":"#ff5e00"},{"gamma":1.2},{"saturation":-23}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"saturation":-64},{"hue":"#ff9100"},{"lightness":16},{"gamma":0.47},{"weight":2.7}]}]

